import { Lightning, Router, Utils } from "@lightningjs/sdk";
import { Card } from "./Card";
import { FOCUS_TRANSITION } from "./focus";
/** Portrait story artwork, with editable captions and an inset focus border. */
export class WSCCard extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._href = "";
        this._title = "";
        this._description = "";
    }
    static _template() {
        const caption = {
            fontFace: "Insatiable Display",
            fontStyle: "700",
            precision: 1,
            w: this.W,
            textAlign: "center",
            wordWrap: false,
            textOverflow: "ellipsis",
            maxLinesSuffix: "…",
        };
        return {
            w: this.W,
            h: this.H,
            clipping: true,
            renderToTexture: true,
            shader: {
                type: Lightning.shaders.RoundedRectangle,
                radius: Card.BORDER_R,
            },
            Poster: {
                w: this.W,
                h: this.H,
                texture: { type: Lightning.textures.ImageTexture },
            },
            Glow: {
                x: -197,
                y: 183,
                w: 716,
                h: 716,
                texture: Lightning.Tools.getSvgTexture(Utils.asset("images/main-stories/blue-glow.svg"), 716, 716),
            },
            Labels: {
                y: 430,
                Title: {
                    text: Object.assign(Object.assign({}, caption), { fontSize: 33, lineHeight: 38, h: 38, offsetY: 31.4, textColor: 0xffdeba37 }),
                },
                Description: {
                    y: 38,
                    text: Object.assign(Object.assign({}, caption), { fontSize: 31, lineHeight: 36, h: 36, offsetY: 29.5, textColor: 0xffffffff }),
                },
            },
            Border: {
                alpha: 0,
                color: Card.BORDER_COLOR,
                texture: Card.borderTexture(this.W, this.H),
            },
        };
    }
    static get width() {
        return this.W;
    }
    static get height() {
        return this.H;
    }
    static get marginRight() {
        return Card.marginRight;
    }
    set title(title) {
        this._title = title;
        this.tag("Labels.Title").patch({ text: { text: title } });
    }
    set description(description) {
        this._description = description;
        this.tag("Labels.Description").patch({ text: { text: description } });
    }
    set posterSrc(posterSrc) {
        this.tag("Poster").patch({ src: posterSrc });
    }
    set posterCrop(posterCrop) {
        this.tag("Poster").patch({
            texture: posterCrop !== null && posterCrop !== void 0 ? posterCrop : { x: 0, y: 0, w: 0, h: 0 },
        });
    }
    set href(href) {
        this._href = href !== null && href !== void 0 ? href : "";
    }
    _focus() {
        this.tag("Border").setSmooth("alpha", 1, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.tag("Border").setSmooth("alpha", 0, FOCUS_TRANSITION);
    }
    _handleEnter() {
        if (this._href)
            Router.navigate("video", {
                href: this._href,
                title: `${this._title}: ${this._description}`,
                category: this.fireAncestors("$getPlaybackCategory") || "Main Stories",
            });
    }
}
WSCCard.W = Card.W;
WSCCard.H = 542;
export default WSCCard;
//# sourceMappingURL=WSCCard.js.map